/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendStandardProductDto } from '../../models/backend-standard-product-dto';
import { BackendStandardProductRequestDto } from '../../models/backend-standard-product-request-dto';

export interface SalesStandardProductsCreate$XWwwFormUrlencoded$Params {
  body?: BackendStandardProductRequestDto;
}

export function salesStandardProductsCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params?: SalesStandardProductsCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendStandardProductDto>> {
  const rb = new RequestBuilder(rootUrl, salesStandardProductsCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendStandardProductDto>;
    }),
  );
}

salesStandardProductsCreate$XWwwFormUrlencoded.PATH = '/api/sales/standard-products/';
